
const SocialMedia = () => {
    
    return (
        <div className="text-center">
        <ul className="ftco-footer-social list-unstyled mt-3">
        <li className="ftco-animate">
          <a href="https://www.youtube.com/@srnmatricschool" target="blank"><span className="fab fa-youtube"></span></a>
        </li>
        <li className="ftco-animate">
          <a href="https://www.facebook.com/SRNMatric" target='blank'><span className="fab fa-facebook-f"></span></a>
        </li>
        <li className="ftco-animate">
           <a href="https://www.instagram.com/srn_matriculation/"  target='blank'><span className="fab fa-instagram"></span></a>
        </li>
      </ul>
    </div>
    )
    

}
export default SocialMedia